import React from "react"
import { Alert } from "react-bootstrap"

export const DataNotFound = (props) => {
    return (
        <Alert variant="warning" className="p-3 text-center">
            <Alert.Heading>{props.title} Not Found!</Alert.Heading>
            <strong>{props.children}</strong>
        </Alert>
    )
}
